module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/cup-ba23a8fbfdd93ef05c8ed577f2ebfa53.png";